export const initialText = `Welcome to our app! Our tool allows you to visualize your data using either pie charts or bar charts. 
Simply choose the chart type you prefer and we'll generate a visual representation of your data for easy interpretation.
 Type your required chart like pie chart or bar chart`;

export const textMsg = "Sorry, I didn't recognize your input. Please type a valid input to see the results.";